import React from "react";

import "./style.scss";

import {
	Stack,
	Typography,
	Link
} from "@mui/material";

import { Trans } from "@lingui/macro";
import { ActionCardProps } from "./models";
import IconComp from "commons/icon-comp/icon-comp";

export class ActionCard extends React.Component<ActionCardProps, {}>
{

	render() {
		return (<>
				<Link href={this.props.href} sx={{textDecoration: "none"}}>
					<Stack alignItems="center" justifyContent="center" spacing={2} className="card-container">
            <IconComp icon={this.props.icon} color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}/>
						<Typography
              variant="h3"
              textAlign="center"
							color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
						>
							<Trans id={this.props.descriptionId}>{this.props.description}</Trans>
						</Typography>
					</Stack>
				</Link>
		</ >);
	}
}
